/**
 * Throw this error when a resource is not found.
 */
export class ResourceNotFoundError extends Error {
  constructor(...args: ConstructorParameters<typeof Error>) {
    super(...args);
    this.name = "ResourceNotFoundError";
  }
}
